export default __webpack_public_path__ + "static/media/1-007.1cb60500.jpg";